export default () => ({
  currentValue: 0,
  maxValue: 0,
  minValue: 0,
  init(){
    const input = this.$el.querySelector('input')
    if(input.value == '') input.value = 0

    this.currentValue = input.value
    this.maxValue = parseInt(input.getAttribute('max')) || null
    this.minValue = parseInt(input.getAttribute('min')) || null

    const minus = (this.minValue != null && this.minValue < 0) ? '-' : ''

    // default max int as 2147483647
    const maxSize = this.maxValue == null ? 2147483647 : this.maxValue
    const minSize = this.minValue == null ? 2147483647 : Math.abs(this.minValue)
    const maxLength = Math.max(maxSize, minSize).toString().length

    // force component attributes
    const mask = `${minus}${Array.from({length: maxLength}).fill('9').join('')}`
    input.setAttribute('x-mask', mask)          // main masking pattern
    input.setAttribute('tabindex', 0)           // tabbing through forms
    input.setAttribute('inputmode', 'numeric')  // no letters for mobile
    // tw style
    input.dataset.slot = 'input'
    input.classList = "flex h-9 w-full rounded-md border border-input bg-transparent py-1 text-sm text-center shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"

    input.addEventListener('change', (e) => {
      this.updateValue(e.target)
    })

    this.$watch('currentValue', (newValue) => {
      input.value = newValue
    })
  },
  updateValue(input){
    if(this.maxValue && input.value > this.maxValue) input.value = this.maxValue
    if(this.minValue && input.value < this.minValue) input.value = this.minValue
    this.currentValue = input.value 
  },
  increment(){
    if(this.maxValue && this.currentValue < this.maxValue){
      this.currentValue++
      this.$nextTick(() => this.$root.querySelector('input').dispatchEvent(new Event('change')))
    }
  },
  decrement(){
    if(this.minValue && this.currentValue > this.minValue){
      this.currentValue--
      this.$nextTick(() => this.$root.querySelector('input').dispatchEvent(new Event('change')))
    }
  }
})